
// cart item increase 
function itemPlus(e, el) {
    var id = $(el).data('id');
    var qty = $(el).prev().val();
    qty = parseInt(qty) + 1;
    
    $.ajax({
        type : "POST",
        url:'/cart/change.js',
        data: {
            id: parseFloat(id),
            quantity: qty
        },
        dataType:'json',
        success:function(data) {
            cart_item_update();
            $('.item-quantity').val(qty);
            // console.log('Increased');
        },
        error:function(err) {
            console.log('Error')
        }
    })
}
// cart item decrease
function itemMinus(e, el) {
    var id = $(el).data('id');
    var qty = $(el).next().val();
    qty = parseInt(qty) - 1;
    if(qty >= 1) {
        $('.item-quantity').val(qty);
        $.ajax({
            type : "POST",
            url:'/cart/change.js',
            data: {
                id: parseFloat(id),
                quantity: qty
            },
            dataType:'json',
            success:function(data) {
                cart_item_update();
                
            },
            error:function(err) {
                console.log('Error')
            }
        })
    }
}
// cart item decrease
function itemRemoved(e, el) {
    var id = $(el).data('id');
    $.ajax({
        type : "POST",
        url:'/cart/change.js',
        data: {
            id: parseFloat(id),
            quantity: 0
        },
        dataType:'json',
        success:function(data) {
            cart_item_update();
        },
        error:function(err) {
            console.log('Error')
        }
    })
}


